import { styled } from "styled-components";
interface ButtonProps {
  $size?: number;
}

export const Button = styled.button<ButtonProps>(({ theme, $size }) => ({
  position: "relative",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: theme.radii.round,
  backgroundColor: theme.colors.primary,
  height: $size || theme.sizes.xl,
  width: $size || theme.sizes.xl,
  overflow: "hidden",
  border: `1px solid ${theme.shadows["4"]}`,
  boxShadow: `0 1px 6px ${theme.shadows["6"]}, 0 2px 24px ${theme.shadows["8"]}`,

  "&:focus": {
    outline: 0,
  },

  "&:hover": {
    cursor: "pointer",
    backgroundColor: theme.colors.primaryDark,
  },

  "& > img": {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },

  padding: 0,
  margin: 0,
}));
